import { Box, Grid, Typography } from "@material-ui/core";
import OrganizationPositionPagesForm from "./organizationPositionPagesForm";

export default function OrganizationPositionEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Organization &gt; Edit Position
        </Typography>
      </Box>
      <Grid container xs={6}>
        <OrganizationPositionPagesForm
          description="Edit Position"
          submitBtnTxt="Save Changes"
          upperBtnPositionSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
